import React from 'react';
import { string, func, number, shape, oneOfType, bool } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import { Link } from '@magalu/stereo-ui/atoms';
import { Wrapper, Content, ImageItem, ArticleContent, Title, TextContainer, Description, ImageContainer } from './LuContentItem.styles';
const IconByType = {
  article: 'Blog',
  video: 'Video',
  podcast: 'Podcast'
};

const LuContentItem = ({
  data,
  cover,
  vertical,
  hide,
  onItemClick,
  onSubItemClick,
  dataTestId,
  itemsSize,
  variation
}) => {
  const {
    type = 'article',
    title,
    subtitle,
    category,
    subcategory,
    image,
    url,
    urlPostSubcategory
  } = data;
  if (!title || !subtitle) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const IconName = IconByType[type] || 'Blog';
  return /*#__PURE__*/React.createElement(Wrapper, {
    role: "button",
    href: url,
    target: url && '_blank',
    "data-testid": dataTestId || 'lu-item',
    onClick: e => onItemClick(e, data),
    "aria-label": `Abre o conteúdo do post ${title}`,
    hide: hide
  }, /*#__PURE__*/React.createElement(Content, {
    "data-testid": "lu-item-content",
    vertical: vertical
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    vertical: vertical
  }, /*#__PURE__*/React.createElement(ImageItem, {
    src: image,
    alt: title,
    vertical: vertical,
    cover: cover,
    itemsSize: itemsSize,
    variation: variation,
    lazy: true
  })), /*#__PURE__*/React.createElement(ArticleContent, {
    vertical: vertical,
    cover: cover,
    "data-testid": "article-content"
  }, /*#__PURE__*/React.createElement(Icon, {
    title: `logo ${type}`,
    name: IconName
  }), /*#__PURE__*/React.createElement(TextContainer, null, /*#__PURE__*/React.createElement(Title, {
    as: "h3"
  }, title), /*#__PURE__*/React.createElement(Description, null, subtitle), category && subcategory && /*#__PURE__*/React.createElement(Link, {
    p: "8px 0",
    color: "text.base",
    fontWeight: "bold",
    onClick: e => onSubItemClick(e, category, subcategory),
    href: urlPostSubcategory
  }, subcategory.title)))));
};

LuContentItem.defaultProps = {
  data: {},
  vertical: false,
  cover: null,
  onItemClick: () => {},
  onSubItemClick: () => {},
  hide: false,
  dataTestId: '',
  itemsSize: 1
};
process.env.NODE_ENV !== "production" ? LuContentItem.propTypes = {
  data: shape({
    id: oneOfType([string, number]),
    type: string,
    title: string,
    subtitle: string,
    image: string
  }),
  // eslint-disable-next-line react/forbid-prop-types
  vertical: bool,
  cover: bool,
  hide: bool,
  dataTestId: string,
  onItemClick: func,
  onSubItemClick: func,
  itemsSize: number,
  variation: string
} : void 0;
export default LuContentItem;